import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

/**
 * Project defaults. The anon/publishable key is safe in client code (every
 * table is protected by row-level security), and hardcoding it means the site
 * keeps working in previews or on hosts where the REACT_APP_* build variables
 * were never configured — without them the CMS content silently disappears.
 */
const fallbackUrl = "https://khqpogisooscbhyofjtc.supabase.co";
const fallbackKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtocXBvZ2lzb29zY2JoeW9manRjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ1Mzk5NDgsImV4cCI6MjEwMDExNTk0OH0.Dvo9LsTlGt6hFy2Fef8YO-9vZkdIylrUjXGXzbPGw60";

export const supabase = createClient(url || fallbackUrl, key || fallbackKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
    storageKey: "zetech-admin-auth",
  },
});
